import useRequestResponse from "./useRequestResponse";
export default function usePermission({
  itemType, itemId, _id, action
}){

  let resolvedId = itemId || _id;
  
  let route = `/checkUserActionPermission?itemType=${itemType}&itemId=${resolvedId}&action=${action}`;
  let [permission] = useRequestResponse(route);

  return permission;






}
